export default __webpack_public_path__ + "static/media/CalendarSvg.4cd20881.svg";